<template>
  <div>
    <exo-form hideClose :root="_self" :clear="false">
      <template v-slot:titleTooltip>
        <exo-help-dialog
          :color="'black--text'"
          margin="m-0"
          title="Maneuver Restitution"
        >
          <b>General description</b>
        </exo-help-dialog>
      </template>
      <exo-input-name :root="_self" />

      <v-row>
        <v-col cols="6">
          <exo-card-form label="Initial conditions">
            <exo-input-ref-notparametric
              :root="_self"
              name="spaceObject"
              type="spaceObject"
              componentRoute="/spaceobject"
            />
          </exo-card-form>
          <exo-card-form label="Mission">
            <v-row>
              <v-col>
                <v-menu bottom transition="scale-transition" offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="pl-6"
                      color="white"
                      outlined
                      dark
                      v-bind="attrs"
                      v-on="on"
                      small
                    >
                      IMPORT
                      <v-icon dark class="ma-0">arrow_drop_down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-on:click="importFileDialog = true"
                      :disabled="this.inputs.measuresFromExternalSource != null"
                    >
                      <v-list-item-title> Import ECI files </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-on:click="getGeneratedMeasures()"
                      :disabled="this.inputs.measuresFromExternalSource != null"
                    >
                      <v-list-item-title>
                        Get measures from database
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-dialog width="700" v-model="dataImporterDialog">
                  <data-importer :root="this"></data-importer>
                </v-dialog>
                <v-dialog scrollable width="550" v-model="importFileDialog">
                  <import-json-file :root="this" />
                </v-dialog>
              </v-col>
            </v-row>
            <div>
              <v-col
                v-if="
                  this.inputs.measuresFromExternalSource &&
                  this.inputs.measuresFromExternalSource[0]
                "
              >
                <v-row>
                  {{
                    this.inputs.measuresFromExternalSource[0].measurements[0]
                  }}
                </v-row>
                <v-row>
                  {{
                    this.inputs.measuresFromExternalSource[0].measurements[1]
                  }}
                </v-row>
                <v-row>
                  {{
                    this.inputs.measuresFromExternalSource[0].measurements[2]
                  }}
                </v-row>
                <v-row>
                  {{
                    this.inputs.measuresFromExternalSource[0].measurements[3]
                  }}
                </v-row>
                <v-row>
                  {{
                    this.inputs.measuresFromExternalSource[0].measurements[4]
                  }}
                </v-row>
                <v-row>
                  {{
                    this.inputs.measuresFromExternalSource[0].measurements[5]
                  }}
                </v-row>
                <v-row>
                  {{
                    this.inputs.measuresFromExternalSource[0].measurements[6]
                  }}
                </v-row>
                <v-row>
                  ...
                  {{
                    this.inputs.measuresFromExternalSource[0].measurements
                      .length - 7
                  }}
                  more ...
                </v-row>
                <v-row>
                  {{
                    this.inputs.measuresFromExternalSource[0].measurements[
                      this.inputs.measuresFromExternalSource[0].measurements
                        .length - 1
                    ]
                  }}
                </v-row>
              </v-col>
            </div>

            <exo-input-double :root="_self" name="targetMissionDuration">
              <exo-help-dialog title="Target mission duration">
                This is the duration expected for the whole mission, including
                initial manoeuvre, drift and final manoeuvre.<br />
                Warning : up to 10% of difference can be observe between the
                effective duration and the expected one.
              </exo-help-dialog>
            </exo-input-double>
          </exo-card-form>
        </v-col>
      </v-row>
    </exo-form>
    <v-col ref="NumericalMissionErrorDisplay"> </v-col>
  </div>
</template>

<script>
import formMixin from '../../mixins/forms.js'
import numericalMixin from '../../mixins/numericalForms.js'
import plotLayout from '../../mixins/plotLayout.js'
import dataTools from '../../tools/data.js'
import missionTools from '../../store/mission.js'
import fieldsDescription from '../../tools/fieldsDescription.json'
import { mapGetters } from 'vuex'
import Vue from 'vue'
import thrustPattern from '@/components/Forms/ThrustPattern.vue'
import ImportEphemeridesFile from '../Defense/ImportEphemeridesFile'

export default {
  name: 'maneuverrestitutionrequest',

  mixins: [formMixin, numericalMixin, plotLayout],
  components: {
    thrustPattern,
    'import-json-file': ImportEphemeridesFile
  },
  computed: {
    ...mapGetters(['missions', 'currentMission']),
    currentStrategyChoice() {
      return this.inputs.maneuveringStrategyChoice
    },

    unconsistantThrustPattern() {
      let t = 1
      let r = 0
      let s = 0
      if (
        this.inputs.numberOfThrustOrbits != null &&
        !isNaN(this.inputs.numberOfThrustOrbits)
      ) {
        t = parseFloat(this.inputs.numberOfThrustOrbits)
      }
      if (
        this.inputs.numberOfRestOrbits != null &&
        !isNaN(this.inputs.numberOfRestOrbits)
      ) {
        r = parseFloat(this.inputs.numberOfRestOrbits)
      }
      if (
        this.inputs.numberOfShiftOrbits != null &&
        !isNaN(this.inputs.numberOfShiftOrbits)
      ) {
        s = parseFloat(this.inputs.numberOfShiftOrbits)
      }
      return s >= t + r
    },

    strategyId() {
      // depending on the mission
      if (this.inputs.type === 'Orbital Transfer') {
        let changeSemiMajorAxis = false
        let changeEccentricity = false
        let changeInclination = false
        changeSemiMajorAxis =
          this.inputs.deltaSemiMajorAxis != null &&
          !isNaN(this.inputs.deltaSemiMajorAxis) &&
          parseFloat(this.inputs.deltaSemiMajorAxis) !== 0
        changeEccentricity =
          this.inputs.deltaEccentricity != null &&
          !isNaN(this.inputs.deltaEccentricity) &&
          parseFloat(this.inputs.deltaEccentricity) !== 0
        changeInclination =
          this.inputs.deltaInclination != null &&
          !isNaN(this.inputs.deltaInclination) &&
          parseFloat(this.inputs.deltaInclination) !== 0
        return (
          'a=' +
          changeSemiMajorAxis +
          ',e=' +
          changeEccentricity +
          ',i=' +
          changeInclination
        )
      }
      return this.inputs.type
    },

    thrustArcsNumberItems() {
      let currentAvailableStrategies =
        this.maneuveringStrategies[this.strategyId]
      let enumItems = this.getPropertiesDescription()['thrustArcsNumber'].values
      if (currentAvailableStrategies != null) {
        enumItems = enumItems.filter((value) =>
          Object.keys(currentAvailableStrategies).includes(value.value)
        )
      }
      return enumItems
    },

    thrustArcsPositionItems() {
      let currentAvailableStrategies =
        this.maneuveringStrategies[this.strategyId]
      let enumItems =
        this.getPropertiesDescription()['thrustArcsPosition'].values
      if (
        currentAvailableStrategies != null &&
        currentAvailableStrategies[this.inputs.thrustArcsNumber] != null
      ) {
        enumItems = enumItems.filter((value) =>
          currentAvailableStrategies[this.inputs.thrustArcsNumber].includes(
            value.value
          )
        )
      }
      return enumItems
    },

    thrustArcsPositionItemsNotCustom() {
      return this.thrustArcsPositionItems.filter(
        (value) => value.value !== 'CUSTOM'
      )
    },

    isOAPMission() {
      return this.inputs.type === 'Maneuvering Strategy Design'
    },

    displayErrorEccentricityWithPerturbations() {
      return this.isPerturbationSelected && this.inputs.deltaEccentricity > 0
    },

    displayErrorEccentricityRAAN() {
      if (this.inputs.type === 'RAAN Phasing') {
        return (
          this.inputs.initialOrbit != null &&
          this.inputs.initialOrbit.eccentricity > 0.01
        )
      } else {
        return false
      }
    },

    displayErrorCoastingAltitude() {
      // Without Number(), the inputs would be compared as string (888>7777)
      return (
        Number(this.inputs.minCoastingAltitude) >
        Number(this.inputs.maxCoastingAltitude)
      )
    },

    displayErrorCoastingInclination() {
      // Without Number(), the inputs would be compared as string (888>7777)
      return (
        Number(this.inputs.minCoastingInclination) >
        Number(this.inputs.maxCoastingInclination)
      )
    },

    displayErrorTargetDeltaLtan() {
      return (
        dataTools.convertGui2si('timeHMS', this.inputs.targetDeltaLtan) === 0
      )
    },

    isPerturbationSelected() {
      return (
        this.inputs.perturbations != null &&
        this.inputs.perturbations.length > 0
      )
    },

    expectedMaxDuration() {
      // for orbit extrapolation we could consider the case when target date provided
      let duration = 0
      for (let durationField of [
        'maximumDuration',
        'duration',
        'targetMissionDuration',
        'targetMissionDurationForAol'
      ]) {
        if (this.isRequiredOrOptional(durationField, this.inputs)) {
          duration = this.inputs[durationField]
        }
      }
      return duration
    },

    attitudeAndSystemSimulatedMessageType() {
      return this.attitudeAndSystemSimulatedMessage.startsWith('Error')
        ? 'error'
        : 'warning'
    },

    attitudeAndSystemSimulatedMessage() {
      if (this.inputs.spacecraft != null) {
        if (
          this.inputs.attitudeAndSystemSimulated != null &&
          this.inputs.attitudeAndSystemSimulated !== ''
        ) {
          if (this.inputs.propagationType === 'SEMI_ANALYTICAL') {
            if (this.inputs.attitudeAndSystemSimulated) {
              return 'Error : the system can not be simulated with the semi-analytical propagation.'
            }
          } else {
            // numerical
            if (
              this.inputs.attitudeAndSystemSimulated &&
              !this.systemDefinedInSpacecraft
            ) {
              return 'Error : the spacecraft has no power system defined.'
            } else if (
              !this.inputs.attitudeAndSystemSimulated &&
              this.systemDefinedInSpacecraft
            ) {
              return 'Info : the selected spacecraft defines a power system but it is not used during the mission.'
            } else if (
              this.inputs.attitudeAndSystemSimulated &&
              (this.inputs.type === 'RAAN Phasing' ||
                this.inputs.type === 'Orbit Phasing')
            ) {
              return "Info : if the thrust duty cycle can not be respected due to the system, the target might not be met. The simulation mission 'Maneuvering Strategy Design' can be used to configure correctly the system."
            } else if (
              this.inputs.attitudeAndSystemSimulated &&
              this.operationSystemDefinedInSpacecraft &&
              this.inputs.type === 'LEO Station Keeping'
            ) {
              return 'Info :  Selected spacecraft defines an Additional system. When not manoeuvring,  operational attitudes will be simulated instead.'
            }
          }
        }
      }
      return ''
    },

    systemDefinedInSpacecraft() {
      return (
        this.inputs.spacecraft != null &&
        this.inputs.spacecraft.powerSystemDefined &&
        this.inputs.spacecraft.spacecraftGeometry &&
        this.inputs.spacecraft.spacecraftGeometry.type !== 'SPHERE'
      )
    },

    operationSystemDefinedInSpacecraft() {
      return this.inputs?.spacecraft?.operationSystemDefined
    },

    isNumericalPropagation() {
      return this.inputs.propagationType === 'NUMERICAL'
    },

    perturbationWatcher() {
      return this.inputs.perturbations
    },

    initialOrbitWatcher() {
      return this.inputs.initialOrbit
    }
  },

  mounted() {
    this.refreshSpaceObjects()
    this.refreshForm()
    this.$root.$on('copy-mission', (mission) => {
      this.copyMission(mission)
    })
    this.$root.$on('create-mission', (mission) => {
      this.createMission(mission)
    })
    this.getCurrentFormTitle()
    this.$root.$on('current-mission-updated', () => {
      this.refreshForm()
    })
  },

  watch: {
    isNumericalPropagation(value) {
      if (!value) {
        this.inputs.ephemeridesThreedChoice = false
        this.inputs.withEclipse = false
        this.inputs.attitudeAndSystemSimulated = false
      }
      this.updateEphemeridesChoices()
    }
  },

  data() {
    return {
      tableFields: [
        { key: 'displayedName', label: 'Name', sortable: true },
        { key: 'type', label: 'Type', sortable: true },
        { key: 'spaceObject', label: 'Space Object', sortable: true },
        { key: 'initialOrbit', label: 'Initial orbit', sortable: true },
        {
          key: 'simulationDuration',
          label:
            'Mission duration' +
            this.getResultDefaultUnitLabel('simulationDuration'),
          sortable: true
        },
        {
          key: 'totalDeltaV',
          label: 'ΔV' + this.getResultDefaultUnitLabel('totalDeltaV'),
          sortable: true
        },
        {
          key: 'totalConsumption',
          label:
            'Used propellant' +
            this.getResultDefaultUnitLabel('totalConsumption')
        },
        { key: 'results', label: 'Result' },
        { key: 'actions', label: 'Actions' }
      ],

      spaceObjectsNotParametrics: null,

      enumPropertiesList: this.getEnumProperties(),

      missionPlot: null,

      modalRef: { content: [] },
      showModal: false,
      maneuveringStrategies: {},

      importFileDialog: false,
      dataImporterDialog: false,

      inputs: {
        measuresFromExternalSource: null,
        initialOrbit: null,
        spaceObject: null,
        type: this.getDefaultValue('type'),
        missionDateTime: this.getDefaultValue('missionDateTime'),
        maximumDuration: this.getDefaultValue('maximumDuration'),
        duration: this.getDefaultValue('duration'),
        perturbations: this.getDefaultValue('perturbations'),
        targetMissionDuration: this.getDefaultValue('targetMissionDuration'),
        layout: this.getDefaultValue('layout'), // to save the dashboard, should be optional in fieldsdescription to be automatically copied
        targetDateDefinitionType: this.getDefaultValue(
          'targetDateDefinitionType'
        ),
        targetDate: this.getDefaultValue('targetDate')
      },

      modalInfo: { title: '', content: '', config: {} },
      modalError: { title: '', content: '' },
      displayed: null
    }
  },

  methods: {
    getGeneratedMeasures() {
      this.$http
        .get('/users/' + this.currentUser.id + '/' + 'measurements/latest')
        .then((response) => {
          const measurements = response.data
          this.inputs.measuresFromExternalSource = measurements.measures
          return measurements.measures
        })
    },

    updateDeltaOrbitalElements(value) {
      if (
        this.inputs.targetDefinition === 'TARGET_ORBIT' &&
        this.inputs.targetOrbit != null &&
        this.inputs.initialOrbit != null
      ) {
        /* not very . this.updateDeltaOrbitalElement('targetRaanLtanType', 'targetDeltaLtan', 'ltan')
        this.updateDeltaOrbitalElement('targetRaanLtanType', 'targetDeltaRaan', 'raan') */
        this.updateDeltaOrbitalElement(
          'deltaInclination',
          'deltaInclination',
          'inclination'
        )
        this.updateDeltaOrbitalElement(
          'deltaEccentricity',
          'deltaEccentricity',
          'eccentricity'
        )
        this.updateDeltaOrbitalElement(
          'deltaSemiMajorAxis',
          'deltaSemiMajorAxis',
          'sma'
        )
      }
    },

    updateDeltaOrbitalElement(conditionField, inputName, orbitField) {
      if (this.isRequiredOrOptional(conditionField, this.inputs)) {
        let delta =
          this.inputs.targetOrbit[orbitField] -
          this.inputs.initialOrbit[orbitField]
        const fieldDesc = this.getPropertiesDescription()[inputName]
        const minInclusive = dataTools.convertPiToNumber(fieldDesc.minInclusive)
        const maxInclusive = dataTools.convertPiToNumber(fieldDesc.maxInclusive)
        if (
          dataTools.isNumber(minInclusive) &&
          dataTools.isNumber(maxInclusive)
        ) {
          const range = maxInclusive - minInclusive
          if (delta > maxInclusive) {
            delta = delta - range
          }
          if (delta < minInclusive) {
            delta = delta + range
          }
        }
        this.inputs[inputName] = dataTools.convertSi2gui(
          this.getFieldType(inputName),
          delta
        )
      }
    },

    updateEphemeridesChoices() {
      if (!this.isNumericalPropagation) {
        this.inputs.ephemeridesOscChoice = false
        this.inputs.ephemeridesMeanChoice = true
      } else {
        if (!this.isPerturbationSelected) {
          // no perturbation : osc = mean => no conversion
          this.inputs.ephemeridesOscChoice = true
          this.inputs.ephemeridesMeanChoice = false
        }
      }
    },

    refreshTable() {},

    getDateTimeString() {
      let date = new Date(this.inputs.initialOrbit.orbitDateTime)
      return date.toUTCString()
    },

    getCurrentFormTitle() {
      return this.inputs.type + ' Mission'
    },

    createMission(mission) {
      if (mission && mission.typeName === this.getCurrentFormType()) {
        this.clearForm()
        this.inputs.type = mission.type
        // set default configuration
        this.inputs.perturbations = ['EARTH_POTENTIAL', 'DRAG']
        this.sendFormToServer()
      }
    },

    copyMission(mission) {
      if (mission && mission.typeName === this.getCurrentFormType()) {
        this.copy(mission)
        this.sendFormToServer()
      }
    },

    clearLocalFields() {
      for (let field in this.getPropertiesDescription()) {
        if (this.inputs.hasOwnProperty(field)) {
          this.inputs[field] = this.getDefaultValue(field)
        }
      }
    },

    refreshForm() {
      if (
        this.currentMission != null &&
        this.currentMission.typeName === this.getCurrentFormType()
      ) {
        if (this.currentMission.id !== this.inputs.id) {
          // different mission reload completely the form
          this.edit(this.currentMission, 0)
        } else {
          // reloading the current mission
          // only refresh the updated fields
          this.updateAllReferences()
          this.inputs.layout = this.currentMission.layout // might be saved from dashboard
        }
      }
    },

    updateAllReferences() {
      this.inputs.editing = true
      this.checkReferences(this.currentMission, this.inputs)
    },

    checkReferences(missionSource, missionToUpdate) {
      if (missionSource != null && missionToUpdate != null) {
        for (let field in this.getPropertiesDescription()) {
          if (missionSource[field] != null && missionToUpdate[field] != null) {
            if (
              missionSource[field].id != null &&
              missionSource[field].id === missionToUpdate[field].id
            ) {
              missionToUpdate[field] = missionSource[field]
            }
          }
        }
      }
    },

    sendFormToServer() {
      this.inputs.saving = true
      this.$http
        .post(this.getCurrentAPI(), this.createObjectFromForm())
        .then((response) => {
          this.inputs.saving = false
          this.$root.$emit('set-current-mission', response.data)
        })
        .catch((e) => {
          this.inputs.saving = false
          this.displayMessage(
            'Error creating ' + this.inputs.type + '. ',
            e,
            'NumericalMissionErrorDisplay',
            'error'
          )
        })
    },
    // redefine from form.js to keep the form open on the upadted data
    onSave(evt) {
      this.inputs.saving = true
      this.$http
        .put(
          this.getCurrentAPI() + '/' + this.inputs.id,
          this.createObjectFromForm()
        )
        .then((response) => {
          this.inputs.saving = false
          this.$root.$emit('update-mission-list')
          this.$root.$emit('set-current-mission', response.data) // update fields and current mission
          // redirect to dashboard
          this.$router.push({
            path:
              '/' +
              missionTools.missionUrlMapping[response.data.typeName].dashboard
          })
        })
        .catch((e) => {
          this.inputs.saving = false
          this.displayMessage(
            'Error creating ' + this.inputs.type + '. ',
            e,
            'NumericalMissionErrorDisplay',
            'error'
          )
        })
    },
    getResultFieldType(field) {
      return dataTools.getFieldTypeFromPath(
        ['maneuverReport', field],
        'SimulationResult',
        null
      )
    },

    getResultDefaultUnitLabel(field) {
      let fieldType = this.getResultFieldType(field)
      return (
        ' ' + dataTools.getUnitLabel(dataTools.getDefaultGuiUnit(fieldType))
      )
    },

    // /////////////// TODO should be merged with mission ///////////
    convertToArray(elements) {
      if (!Array.isArray(elements)) {
        return [elements]
      } else {
        return elements
      }
    },

    removeParameter(index) {
      this.configuration.targets.splice(index, 1)
    },

    mergeString(inputElements, fieldPath) {
      let uniqueVals = dataTools.getUniqueValues(
        this.convertToArray(inputElements),
        fieldPath
      )
      if (uniqueVals.length === 1) {
        return uniqueVals[0]
      } else {
        return uniqueVals
      }
    },

    isStringInside(expected, inputElements, fieldPath) {
      let elements = this.convertToArray(inputElements)
      return (
        elements.filter(
          (element) => dataTools.getValue(element, fieldPath) === expected
        ).length > 0
      ) // TODO MFI stop on first would be better
    },

    // Methods to manage result popup
    info(mission, button) {
      this.modalInfo.title = mission.name
      this.modalInfo.content = [mission]
      this.modalInfo.errorLog = mission.computationLog
      this.$root.$emit('bv::show::modal', 'modalInfo', button)
    },

    resetModal() {
      this.modalInfo.title = ''
      this.modalInfo.content = ''
      this.modalError.title = ''
      this.modalError.content = ''
      this.modalInfo.errorLog = ''
    },

    // TODO MFI delete ?
    displayErrorLog(mission, button) {
      this.modalError.title = mission.name
      this.modalError.content = mission.computationLog
      this.$root.$emit('bv::show::modal', 'modalError', button)
    },

    // Methods to compute &  export result
    displayPlot(mission) {
      if (!mission) {
        this.$refs.plotMission.setMission(null, null, null)
        return
      }
      if (this.displayed === null || this.displayed === '3d') {
        this.$refs.three.setMission(null, null, null)
        this.displayed = 'plot'
      }
      this.missionPlot = mission
      this.$refs.plotMission.setMission(
        mission,
        mission.results.ephemerides,
        mission.results.fieldIndexes
      )
    },

    setMissionConfiguration(config) {
      this.missionPlot.plotConfiguration = JSON.parse(JSON.stringify(config)) // copy values, not ref
    },

    // methods to mange form & table like other components

    getCurrentFormType() {
      return 'ManeuverRestitutionRequest'
    },

    refreshSpaceObjects() {
      let self = this
      this.$http
        .get(this.getAPI('spaceobjectdefinitions'))
        .then((response) => {
          self.spaceObjectsNotParametrics = response.data
            .filter((obj) => !obj.displayedName.endsWith('*'))
            .map((obj) => ({ value: obj, text: obj.displayedName }))
            .sort((a, b) =>
              a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1
            )
        })
        .catch((e) => {
          self.displayMessage(
            'Error getting list of space objects. ',
            e,
            'NumericalMissionErrorDisplay',
            'error'
          )
        })
    },

    getMissionType(mission) {
      let types = { type: mission.type }
      return types
    },

    getSubTypes(instance) {
      //TODO clean code
      return null
    },

    getRequiredPropertiesList(instance) {
      let subTypes = this.getSubTypes(instance)
      let objectType = this.getCurrentFormType()
      let requiredList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        subTypes,
        'required'
      )
      return requiredList
    },

    getOptionalPropertiesList(instance) {
      let subTypes = this.getSubTypes(instance)
      let objectType = this.getCurrentFormType()
      let optionalList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        subTypes,
        'optional'
      )
      return optionalList
    },

    getAllPropertiesUnionList() {
      let objectType = this.getCurrentFormType()
      let requiredList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        null,
        'required'
      )
      let optionalList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        null,
        'optional'
      )
      return [...new Set(requiredList.concat(optionalList))]
    },

    // ---------------------- field checks -----------------
    // duplicated for special check on perturbations
    getEnumFieldState(parentObject, fieldName, required) {
      let state = {
        value: true, // do not initialize with null, it means field empty
        message: true
      }
      if (parentObject[fieldName] == null && !required) {
        return state
      }
      let fieldDesc = this.getPropertiesDescription()[fieldName]
      state.value = false
      state.message = 'Please select a valid value'
      if (Array.isArray(parentObject[fieldName])) {
        if (required && parentObject[fieldName].length === 0) {
          state.value = false
          state.message = 'Please select at least one value'
        } else {
          // if multi select (no value set can be a right value)
          state.value = true
          state.message = true
        }
      } else {
        for (let value in fieldDesc.values) {
          if (fieldDesc.values[value].value === parentObject[fieldName]) {
            state.value = true
            state.message = true
          }
        }
      }
      if (fieldName === 'perturbations' && parentObject.spacecraft != null) {
        if (
          parentObject[fieldName] &&
          parentObject[fieldName].includes('SRP') &&
          !parentObject.spacecraft.srpModelDefined
        ) {
          state.value = false
          state.message =
            'Sun radiation pressure model not defined in spaceObject'
        }
        if (
          parentObject[fieldName] &&
          parentObject[fieldName].includes('DRAG') &&
          !parentObject.spacecraft.dragModelDefined
        ) {
          state.value = false
          state.message = 'Drag model not defined in spaceObject'
        }
      }
      return state
    }
  }
}
</script>
